// Because these are used both as radio button (or similar) values and
// as strigns displayed to the user.
export const TO_MY_ADDRESS = "To my address";
export const TO_PATIENTS_ADDRESS = "To the patient’s address";
export const SOMEWHERE_ELSE = "Somewhere else";

export const ME = "Me";
export const THE_PATIENT = "The patient";
export const SOMEONE_ELSE = "Someone else";

export const FOREIGN_LANGUAGE_INTERPRETATION = "Foreign language interpretation";
export const ASL = "ASL";

export const NOT_PROVIDED = "(Not provided)";
